import Smartphones from 'User/Settings/views/SettingsView/containers/Smartphones'
import Tablets from 'User/Settings/views/SettingsView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const SettingsView = getCurrentDeviceView(Smartphones, Tablets)

export default SettingsView
